import { peopleStories } from "@/mocks/positiveNews";

export default function PeopleSection() {
  return (
    <section id="people" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            人物特写 · PEOPLE
            <span className="h-px w-6 bg-primary-400" />
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">这些平凡人，正在默默发光</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            不夸张、不煽情，我们认真记录普通人不普通的选择。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {peopleStories.map((p) => (
            <article
              key={p.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 sm:flex-row"
            >
              <div className="relative h-56 w-full shrink-0 overflow-hidden sm:h-auto sm:w-44">
                <img
                  src={p.img}
                  alt={`人物特写：${p.name}`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 sm:object-cover"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex items-center justify-between gap-2">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{p.name}</h3>
                    <p className="mt-0.5 text-xs text-foreground-500">{p.role}</p>
                  </div>
                  <span className="whitespace-nowrap rounded-full bg-background-200 px-2.5 py-1 text-[11px] text-foreground-600">
                    {p.place}
                  </span>
                </div>

                <h4 className="mt-3 text-base font-bold leading-snug text-primary-700 md:text-lg">{p.title}</h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{p.story}</p>
                <blockquote className="mt-3 rounded-xl border-l-2 border-accent-500 bg-accent-100/60 px-3 py-2 text-sm italic leading-relaxed text-foreground-700">
                  “{p.quote}”
                </blockquote>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}